// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shadow-md{box-shadow:0 4px 6px -1px rgba(0,0,0,.34),0 2px 4px -1px rgba(0,0,0,.06)}.custom-file-input::-webkit-file-upload-button{visibility:hidden}.custom-file-input:before{content:\"Upload\";display:inline-block;background:#1f677e;border-radius:3px;padding:5px 5px;outline:none;color:#fff;white-space:nowrap;-webkit-user-select:none;cursor:pointer;font-weight:700;font-size:14px}.custom-file-input:active:before{background:-webkit-linear-gradient(top,#e3e3e3,#f9f9f9)}", ""]);
// Exports
module.exports = exports;
